const AUTH_STORAGE = '@dwf:token'
const USER_STORAGE = '@dwf:user'
const EMAIL_STORAGE = '@dwf:email'
const PROFESSIONAL_ATHLETE_SELECTED = '@dwf:athlete-selected'
const BREADCRUMB_STORAGE = '@dwf:breadcrumb'
const RESTRICTIONS_STORAGE = '@dwf:restrictions'

export {
  USER_STORAGE,
  AUTH_STORAGE,
  EMAIL_STORAGE,
  PROFESSIONAL_ATHLETE_SELECTED,
  BREADCRUMB_STORAGE,
  RESTRICTIONS_STORAGE
}
